export const EMAIL_DELIVERY = {
  CONFIRMATION_REQUEST: "confirmation_request",
  COMMENT_MENTION: "comment_mention",
  PAYMENT_DEADLINE_EXCEEDED: "payment_deadline_exceeded",
  BILLING_DATE_EXCEEDED: "billing_date_exceeded",
  JOIN_DATE_EXCEEDED: "join_date_exceeded",
  VISA_INTEGRATION_CHANGE: "visa_integration_change",
  MATCH_INTEGRATION_DRAFT_ORDER: "match_integration_draft_order",
  IROHANA_NOTICE: "irohana_notice",
} as const;

export type TEmailDelivery = (typeof EMAIL_DELIVERY)[keyof typeof EMAIL_DELIVERY];

export type TNotificationOption = {
  value: TEmailDelivery;
  label: string;
  subLabel: string;
};

export type TNotificationGroup = {
  title: string;
  options: TNotificationOption[];
};

export const NOTIFICATION_GROUPS: TNotificationGroup[] = [
  {
    title: "各種依頼",
    options: [
      { value: EMAIL_DELIVERY.CONFIRMATION_REQUEST, label: "確認依頼", subLabel: "自分宛の確認依頼通知" },
      { value: EMAIL_DELIVERY.COMMENT_MENTION, label: "コメント機能のメンション", subLabel: "自分宛のメンション通知" },
    ],
  },
  {
    title: "各種アラート",
    options: [
      { value: EMAIL_DELIVERY.PAYMENT_DEADLINE_EXCEEDED, label: "支払期限超過", subLabel: "入金待ち請求が支払期限日を過ぎた場合（日次）に通知" },
      { value: EMAIL_DELIVERY.BILLING_DATE_EXCEEDED, label: "請求日超過", subLabel: "送付前の請求が請求日を過ぎた場合に通知" },
      { value: EMAIL_DELIVERY.JOIN_DATE_EXCEEDED, label: "入社予定日超過", subLabel: "入社予定日超過時に通知" },
    ],
  },
  {
    title: "各種連携",
    options: [
      { value: EMAIL_DELIVERY.VISA_INTEGRATION_CHANGE, label: "visa連携（変更通知）", subLabel: "担当受注の入社日変更・退職・在留資格変更・下書き更新などの通知" },
      { value: EMAIL_DELIVERY.MATCH_INTEGRATION_DRAFT_ORDER, label: "match連携（仮登録受注の確認依頼）", subLabel: "matchから受注が下書きで自動作成された場合の通知" },
    ],
  },
  {
    title: "その他",
    options: [{ value: EMAIL_DELIVERY.IROHANA_NOTICE, label: "システム通知（お知らせ）", subLabel: "サービス内のシステム変更時の通知" }],
  },
];

export const ALL_EMAIL_DELIVERY_VALUES: TEmailDelivery[] = NOTIFICATION_GROUPS.flatMap((group) => group.options.map((option) => option.value));
